if (!customElements.get('nox-model-selector')) {
  customElements.define('nox-model-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = [...this.querySelectorAll('[data-model-card]')];
      this.form = this.querySelector('form');
      this.quantity = this.querySelector('[name="quantity"]');
      this.galleryIndex = 0;
      this.dialog = this.querySelector('.nox-premium-zoom');
      this.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-premium-thumbnail]');
        if (thumbnail) this.selectPhoto(Number(thumbnail.dataset.premiumThumbnail));
        const direction = event.target.closest('[data-premium-direction]');
        if (direction) this.selectPhoto(this.galleryIndex + Number(direction.dataset.premiumDirection));
        if (event.target.closest('[data-premium-zoom]')) {
          const image = this.querySelector(`[data-premium-panel="${this.galleryIndex}"] img`);
          if (image) {
            this.querySelector('[data-premium-zoom-content]').replaceChildren(image.cloneNode(true));
            this.dialog.showModal();
          }
        }
        if (event.target.closest('[data-premium-close]')) this.dialog.close();
        const card = event.target.closest('[data-model-card]');
        if (card && !event.target.closest('.nox-model-colors') && !event.target.closest('[data-model-choice], [data-model-add]')) this.selectModel(card);
        const quantityButton = event.target.closest('[data-model-quantity]');
        if (quantityButton) {
          if (quantityButton.dataset.modelQuantity === '1') this.quantity.stepUp();
          else this.quantity.stepDown();
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }

      });
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-model-color]')) return;
        const card = event.target.closest('[data-model-card]');
        card.querySelectorAll('[data-color-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.colorPanel !== event.target.value;
        });
      });
      this.quantity.addEventListener('input', () => this.updateQuantityButtons());
      this.quantity.addEventListener('change', () => this.updateQuantityButtons());
      this.form.addEventListener('submit', (event) => {
        if (this.addingToCart) {
          event.preventDefault();
          return;
        }
        const card = event.submitter?.closest('[data-model-card]') ||
          this.cards.find((item) => item.classList.contains('is-selected'));
        if (this.dataset.ready !== 'true' || card.dataset.available !== 'true') {
          event.preventDefault();
          this.quantity.setCustomValidity('Ce modèle est indisponible pour le moment.');
          this.quantity.reportValidity();
          return;
        }
        this.quantity.setCustomValidity('');
        this.selectModel(card, true);
        if (!this.quantity.reportValidity()) {
          event.preventDefault();
          return;
        }
        const color = card.querySelector('[data-model-color]');
        this.querySelector('[data-purchase-model]').value = card.dataset.modelName;
        this.querySelector('[data-purchase-color]').value = color.selectedOptions[0].textContent;
        if (event.submitter?.matches('[data-model-add]')) {
          event.preventDefault();
          this.addToCart(event.submitter);
        }
      });
      this.selectModel(this.cards.find((card) => card.classList.contains('is-selected')) || this.cards[0]);
      this.selectPhoto(0);
    }

    async addToCart(trigger) {
      const errorMessage = this.querySelector('[data-model-cart-error]');
      errorMessage.hidden = true;
      const buttons = [...this.querySelectorAll('[data-model-add], [data-model-choice]')];
      const disabledStates = buttons.map((button) => button.disabled);
      this.addingToCart = true;
      buttons.forEach((button) => { button.disabled = true; });
      trigger.setAttribute('aria-busy', 'true');
      try {
        const cart = document.querySelector('cart-drawer');
        if (!cart) throw new Error('Le panier est indisponible. Rechargez la page puis réessayez.');
        const data = new FormData(this.form);
        data.delete('return_to');
        data.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
        data.append('sections_url', window.location.pathname);
        cart.setActiveElement(trigger);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = data;
        const response = await fetch(window.routes.cart_add_url, config);
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || window.cartStrings.error);
        if (!result.sections || cart.getSectionsToRender().some((section) => !result.sections[section.id])) {
          throw new Error('Le produit a été ajouté, mais le panier ne peut pas être affiché. Rechargez la page pour le consulter.');
        }
        cart.classList.remove('is-empty');
        cart.renderContents(result);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'nox-model-selector',
          productVariantId: data.get('id'),
          cartData: result,
        });
      } catch (error) {
        console.error('Nox model cart:', error);
        errorMessage.textContent = error.message || window.cartStrings.error;
        errorMessage.hidden = false;
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'nox-model-selector',
          errors: errorMessage.textContent,
          message: errorMessage.textContent,
        });
      } finally {
        this.addingToCart = false;
        buttons.forEach((button, index) => { button.disabled = disabledStates[index]; });
        trigger.removeAttribute('aria-busy');
      }
    }

    selectPhoto(index) {
      const panels = [...this.querySelectorAll('[data-premium-panel]')];
      if (index < 0 || index >= panels.length) return;
      this.galleryIndex = index;
      panels.forEach((panel, position) => { panel.hidden = position !== index; });
      this.querySelectorAll('[data-premium-thumbnail]').forEach((button, position) => {
        button.setAttribute('aria-pressed', String(position === index));
      });
      this.querySelector('[data-premium-direction="-1"]').disabled = index === 0;
      this.querySelector('[data-premium-direction="1"]').disabled = index === panels.length - 1;
      this.querySelector('[data-premium-zoom]').disabled = !panels[index].querySelector('img');
    }

    selectModel(card, preserveQuantity = false) {
      const previousQuantity = this.quantity.value;
      this.quantity.setCustomValidity('');
      this.cards.forEach((item) => {
        const selected = item === card;
        item.classList.toggle('is-selected', selected);
        item.querySelector('[data-model-choice]').setAttribute('aria-pressed', String(selected));
      });
      const ready = this.dataset.ready === 'true';
      this.querySelector('[data-model-variant]').value = ready ? card.dataset.variantId : '';
      this.querySelector('[data-selected-name]').textContent = `Modèle ${card.dataset.modelName}`;
      this.querySelector('[data-selected-price]').textContent = card.dataset.price;
      this.quantity.min = card.dataset.min;
      this.quantity.step = card.dataset.step;
      if (card.dataset.max) this.quantity.max = card.dataset.max;
      else this.quantity.removeAttribute('max');
      this.quantity.value = preserveQuantity ? previousQuantity : card.dataset.min;
      this.updateQuantityButtons();
    }

    updateQuantityButtons() {
      const value = Number(this.quantity.value);
      this.querySelector('[data-model-quantity="-1"]').disabled = value <= Number(this.quantity.min);
      this.querySelector('[data-model-quantity="1"]').disabled =
        this.quantity.max !== '' && value >= Number(this.quantity.max);
    }
  });
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('.nox-premium-menu a');
  if (link) link.closest('details').open = false;
});
